// cart-gift-handler.js — auto gifts with suppression + debounced sync (unified via PBCart)

// --- Suppression helpers (user removed a gift -> don't auto re-add this session) ---
function loadSuppressedVariantIds() {
  try {
    const raw = JSON.parse(sessionStorage.getItem('ucd_suppressed_gift_variants') || '[]');
    const out = new Set();
    (raw || []).forEach(v => { const n = Number(v); if (Number.isFinite(n)) out.add(n); });
    return out;
  } catch { return new Set(); }
}

function loadLegacySuppressedIds() {
  try {
    const raw = JSON.parse(sessionStorage.getItem('ucd_suppressed_gifts') || '[]');
    const vids = new Set();
    (raw || []).forEach(s => {
      if (typeof s === 'string' && s.startsWith('v:')) {
        const n = Number(s.slice(2));
        if (Number.isFinite(n)) vids.add(n);
      }
    });
    return vids;
  } catch { return new Set(); }
}

function loadAllSuppressedVariantIds() {
  const a = loadSuppressedVariantIds();
  const b = loadLegacySuppressedIds();
  b.forEach(v => a.add(v));
  return a;
}

(function () {
  const drawer = document.getElementById('UnifiedCartDrawer');
  if (!drawer) return;

  const debugDiv = document.getElementById('debugDiv');
  const dlog = (o) => { if (debugDiv) debugDiv.textContent = JSON.stringify(o, null, 2); };

  const qs = (sel) => Array.from(drawer.querySelectorAll(sel));
  const tiersFromBlocks = () =>
    qs('[data-tier]').map(n => ({
      threshold: Number(n.dataset.threshold || 0),      // euros
      rewardType: n.dataset.rewardType || '',
      giftVariantId: n.dataset.giftVariantId ? Number(n.dataset.giftVariantId) : null
    }))
    .filter(t => t.rewardType === 'free_product' && t.giftVariantId);

  let syncing = false;
  let timer;

  async function syncGifts() {
    if (syncing) return;
    syncing = true;
    try {
      const tiers = tiersFromBlocks().sort((a,b)=>a.threshold-b.threshold);
      if (!tiers.length) return;

      const gqlCart = await PBCart.refresh();
      const subtotal = Math.round(parseFloat(gqlCart.cost?.subtotalAmount?.amount || 0) * 100); // cents

      // Which gift variants are eligible given subtotal
      const desired = new Set(
        tiers
          .filter(t => subtotal >= t.threshold * 100)
          .map(t => t.giftVariantId)
      );

      // Respect suppression
      const suppressed = loadAllSuppressedVariantIds();
      const desiredFiltered = new Set([...desired].filter(vid => !suppressed.has(Number(vid))));

      // What's currently in cart
      const giftItems = (gqlCart.lines?.edges || [])
        .map(e => e.node)
        .filter(n => (n.attributes || []).some(a => a.key === '_auto_gift' && a.value === 'true'));

      const present = new Set(giftItems.map(n => {
        const merch = n.merchandise;
        return merch?.id ? Number(merch.id.split('/').pop()) : null;
      }).filter(Boolean));

      let changed = false;

      // Add missing gifts
      for (const vid of desiredFiltered) {
        if (!present.has(vid)) {
          await PBCart.addLine(vid, 1, [{ key: "_auto_gift", value: "true" }]);
          changed = true;
        }
      }

      // Remove gifts no longer eligible
      for (const gi of giftItems) {
        const merch = gi.merchandise;
        const vid = merch?.id ? Number(merch.id.split('/').pop()) : null;
        if (vid && !desiredFiltered.has(vid)) {
          await PBCart.removeLine(gi.id);
          changed = true;
        }
      }

      if (changed) {
        document.dispatchEvent(new CustomEvent('pb:cart:updated', { detail:{ source:'gifts', cart: gqlCart } }));
      }

      dlog({
        action:'syncGifts',
        subtotal,
        desired:[...desired],
        desiredFiltered:[...desiredFiltered],
        present:[...present],
        suppressed:[...suppressed],
        changed
      });
    } catch (e) {
      dlog({ action:'syncGifts:error', message: String(e) });
    } finally {
      syncing = false;
    }
  }

  function requestSync() {
    clearTimeout(timer);
    timer = setTimeout(syncGifts, 180);
  }

  document.addEventListener('DOMContentLoaded', requestSync);
  document.addEventListener('pb:cart:updated', (e) => {
    // Skip refresh-only events to avoid the loop:
    // syncGifts() calls PBCart.refresh() which fires pb:cart:updated(source:"refresh")
    // → without this guard that would re-trigger syncGifts() endlessly.
    const source = e.detail?.source;
    if (source === 'refresh' || source === 'refresh:new' || source === 'boot') return;
    requestSync();
  });
})();